import React from "react";
import { TypeOf } from 'zod';
import {Save} from "@mui/icons-material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {Button, Stack, Box, Badge,} from "@mui/material";
import useEntity from "../../../hooks/useTimberType";
import {PrimaryTimberType} from "../../../types/models/TimberType";
import {useGetTimberTypeQuery} from "../../../apis/TimberType.api";
import TimberTypeUpdateForm, {formSchema, initialFormStateFn} from "../../../components/timberType/TimberTypeForm/TimberTypeUpdateForm";
import { Trans } from "@lingui/react/macro";

export type FormInput = TypeOf<typeof formSchema>;

const TimberTypeUpdateFormProvider = ({ id, initialFormState, cancelButton = undefined, redirectPath = undefined, successAction = undefined }) => {

    const primary = PrimaryTimberType.fromPath(id);
    const { data, isLoading } = useGetTimberTypeQuery(primary)

    const methods = useForm<FormInput>({
        resolver: zodResolver(formSchema),
        defaultValues: initialFormState(data)
    });
    const {  updateTimberType } = useEntity();

    const {
        watch,
        reset,
        handleSubmit,
        formState: { isSubmitSuccessful, errors, },
    } = methods;

    React.useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data, reset]);

    
    const onSubmitHandler: SubmitHandler<FormInput> = async (values) => {
        const data = await updateTimberType({
            id: primary,
            data: values,
        }, redirectPath)
        if (data && successAction) {
            successAction(data)
        }
    };

    return (
        <>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={
                        (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleSubmit(onSubmitHandler)(e)
                        }
                    }
                    noValidate
                >

                    <TimberTypeUpdateForm watch={watch}/>

                    <Stack direction="row" justifyContent="end" spacing={1} padding={5}>

                        { cancelButton }

                        
                        <Badge badgeContent={Object.values(errors).length} color="error" anchorOrigin={ {vertical: 'bottom'} }>
                            <Button size="medium" variant="contained" color="primary" type='submit' startIcon={<Save />}>
                                <Trans>Update</Trans>
                            </Button>
                        </Badge>
                    </Stack>
                </Box>
            </FormProvider>
        </>
    )
}

export default TimberTypeUpdateFormProvider
